import type {SubAgent} from '../types/agent'
import {fetchCAPI} from '../utils/fetch-capi'
import {useCAPIQuery} from './useCAPIQuery'

export function useSubAgents({repo, enabled}: {repo: {owner: string; nameOnly: string}; enabled?: boolean}) {
  const query = useCAPIQuery<SubAgent[]>({
    queryKey: ['custom-agents', repo.owner, repo.nameOnly],
    enabled,
    queryFn: async () => {
      try {
        const response = await fetchCAPI({
          path: `/agents/swe/custom-agents/${repo.owner}/${repo.nameOnly}`,
          retryOn401: true,
        })

        if (response.status === 404) {
          return []
        }

        const data = await response.json()
        const agents = data.agents as SubAgent[]

        return agents
      } catch {
        return []
      }
    },
  })

  return query
}
